// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"32192185","146":"b9f605e1","306":"2e7f74b3","453":"a66e93a3","832":"4c5e03a1","835":"e9531919"}[chunkId] + ".chunk.js";
};